import { FormikValues, useFormikContext } from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import { IMaskInput } from 'react-imask';

import { Grupo, Rotulo } from '.';
import Ajuda from './Ajuda';
import { FormContexto } from './Form';

interface Props {
  ajuda?: string;
  name: string;
  rotulo?: string;
  type?:
    | 'text'
    | 'date'
    | 'datetime'
    | 'datetime-local'
    | 'color'
    | 'email'
    | 'number'
    | 'password'
    | 'tel'
    | 'url'
    | 'time';
  semMargem?: boolean;
  prefixar?: string | React.ReactElement;
  mascara?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  aoAtualizar?: (valor: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  aoDeixar?: (valor: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  forcarValor?: any;
  desabilitarAoForcar?: boolean;
  desativado?: boolean;
}

const Campo = (props: Props): React.ReactElement => {
  const [desativado, setDesativado] = useState<boolean>(false);
  const { emLinha } = useContext(FormContexto);
  const {
    ajuda,
    name,
    type = 'text',
    rotulo,
    prefixar,
    forcarValor,
    desabilitarAoForcar = true,
  } = props;
  const {
    handleBlur,
    handleChange,
    setFieldValue,
    getFieldMeta,
  } = useFormikContext<FormikValues>();
  const { value, error, touched } = getFieldMeta(name);

  useEffect(() => {
    if (forcarValor) {
      setFieldValue(name, forcarValor, true);

      if (desabilitarAoForcar) {
        setDesativado(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forcarValor]);

  const valor = () => {
    if (type == 'datetime-local' && value) {
      return (value as string).data().toFormat('yyyy-LL-dd\'T\'T');
    }

    return value;
  };

  return (
    <React.Fragment>
      <Grupo
        semMargem={emLinha || props.semMargem}
        prefixar={prefixar}
        emLinha={emLinha}
      >
        <IMaskInput
          type={type}
          name={name}
          className={`form-control ${error && touched && 'is-invalid'}`}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onChange={(e: any) => {
            if (props.aoAtualizar) {
              props.aoAtualizar(e.currentTarget.value);
            }

            handleChange(e);
          }}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onBlur={(e: any) => {
            if (props.aoDeixar) {
              props.aoDeixar(e.currentTarget.value);
            }

            handleBlur(e);
          }}
          value={valor()}
          placeholder={rotulo}
          mask={props.mascara || ''}
          {...(desativado || props.desativado ? { disabled: true } : {})}
        />
        <React.Fragment>
          {!emLinha && rotulo && <Rotulo name={name}>{rotulo}</Rotulo>}
        </React.Fragment>
        <div className="invalid-tooltip">{error && touched && error}</div>
      </Grupo>
      {ajuda && (
        <div className={['mt-n3', !props.semMargem && 'mb-3'].class()}>
          <Ajuda>{ajuda}</Ajuda>
        </div>
      )}
    </React.Fragment>
  );
};

export default Campo;
